import React, {useEffect} from 'react';
import { EventTypeFilter } from '../../Models/EventTypeFilter';
import { EventType } from '../../Models/EventType';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { makeStyles } from '@mui/styles';
import './Modal.scss';
import { useViewableEventTypes } from '../../providers/ViewEventTypeProvider';
import { useSelector } from 'react-redux';

interface FilterModalProps {
  isModalOpen: boolean;
  onApplyFilter: (event: any) => void;
  close: () => void;
  filteredEventTypes: EventTypeFilter[] | undefined;
  sortSelected:(string: any) => void;
  onCheckedCount: any;
}

const useStyles = makeStyles((theme) => ({
    customCheckbox: {
        fontFamily: 'var(--auro-font-family-default) !important',
        color: '#00274A !important',
        fontSize: '16px !important',
        fontStyle: 'normal !important',
        fontWeight: '450',
        borderRadus: '10px !important',
        padding: '4px 0px 0px 0px !important',
        boxShadow: 'none !important',
    },
}));

const FilterModal: React.FC<FilterModalProps> = ({ isModalOpen, close, onApplyFilter, filteredEventTypes,sortSelected, onCheckedCount }) => {
    const classes = useStyles();
    const viewEventTypes = useViewableEventTypes()?.viewEventTypes;
    const [filters, setFilters] = React.useState<EventTypeFilter[]>([]);
    const currentSort = useSelector((state: any) => state.filterSort.sort);
    const [value, setValue] = React.useState("");
    const modalRef = React.useRef<HTMLDivElement>(null);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        sortSelected((event.target as HTMLInputElement).value);
    };

    //set sort value
    useEffect(() => {
        setValue(currentSort);
    }, [currentSort]);
    
    function eventTypeChecked(event, eventTypeName: string) { 
        let selected = [...filters];
        let index = selected.findIndex((eventType: EventTypeFilter) => eventType.Name === eventTypeName);
      
        selected[index].IsChecked = event.target.checked;
        console.log("Setting filter", index, "to", event.target.checked)
        setFilters(selected);  
        onApplyFilter(selected);
    }

    function checkedCount(filtersList: any ) {
        // count the number of checked filters
        let checkedCount = filtersList.filter((eventType: EventTypeFilter) => eventType.IsActive && eventType.IsChecked === true).length;
        if(viewEventTypes && checkedCount === viewEventTypes.filter(eventType => eventType.IsActive).length) {
            onCheckedCount("All");
        }
        else {
            onCheckedCount(checkedCount);
        }
    }

    const checkFilteredEventType=()=>{
        if(filteredEventTypes){
            if(filteredEventTypes.length>0){
                return false;
            }
            else{
                return true;
            }
        }
        else{
            return true;
            }
        }


    useEffect(() => {
        if (viewEventTypes) {
            // if there are any applied  event type filters - default everything to OFF, otherwise, turn them all ON (no filters).
            let defaultChecked: boolean = checkFilteredEventType();
            const filters: EventTypeFilter[] = viewEventTypes.map((eventType: EventType) => {
                return { 
                    Id: eventType.Id,
                    Name: eventType.Name, 
                    Airline:  eventType.Airline,
                    IsActive: eventType.IsActive,
                    IsChecked: eventType.IsActive ? defaultChecked : false,
                    IsLocked: eventType.IsLocked
                };
            });
            
            // if there are applied filter event types - selectively turn them on
            if(filteredEventTypes) { 
                filteredEventTypes.forEach((filteredEventType: EventTypeFilter) => {
                    let index = filters.findIndex((eventType: EventTypeFilter) => eventType.Name === filteredEventType.Name);
                    if (index > -1) {
                        console.log("Setting filter", index, "to", filteredEventType.IsChecked)
                        filters[index].IsChecked = filteredEventType.IsChecked;
                    }

                });
            }
            console.log("Setting filters using the input filteredEventTypes", filters);
            //if any locked filters are unchecked, turn them on
            let refreshFilterList = false;
            filters.forEach((filter: EventTypeFilter) => {
                if (filter.IsLocked && !filter.IsChecked) {
                    filter.IsChecked = true;
                    refreshFilterList = true;
                }
            });

              // order the filters by IsLocked === true first then by name 
            filters.sort((a, b) => (a.IsLocked === b.IsLocked) ? a.Name.localeCompare(b.Name) : compareIt(a));
            console.log("Sorted filters", filters);
            setFilters(filters);
            if (refreshFilterList) {
                onApplyFilter(filters);
            }
            checkedCount(filters);
        }
        return () => {
        }
    }, [viewEventTypes, filteredEventTypes]);

    const compareIt=(a:any)=>{
        if(a.IsLocked){
            return -1;
        }
        else{
            return 1;
        }
    }

    useEffect(() => {  
        const closeOnEscapeKeyDown = (e: any) => {
            if ((e.charCode || e.keyCode) === 27) {
            close();
            }
        }
        document.addEventListener('keydown', closeOnEscapeKeyDown);
    
        return () => document.removeEventListener('keydown', closeOnEscapeKeyDown);
        
    }, [isModalOpen]);

    const handleApplyAll = () => {
        let selected = [...filters];
        selected.forEach((eventType: EventTypeFilter) => {
            if (eventType.IsActive) {
                eventType.IsChecked = true;
            }
        });
        setFilters(selected);
        onApplyFilter(selected);
    };
    const handleClearAll = () => {
        let selected = [...filters];
        selected.forEach((eventType: EventTypeFilter) => {
            if (eventType.IsActive && !eventType.IsLocked) {
                eventType.IsChecked = false;
            }
        });
        setFilters(selected);
        onApplyFilter(selected);
    };

    

  if (!isModalOpen) {
    return null;
  }
  return (
    <div className="positioned-div-container">
        <div>
            <div className="filter-header">
                <div className="filter-title">
                    <span>Sort & filter</span>
                </div>
                <div style={{"height": "20px"}}><button className="filter-close-icon" onClick={close}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.39705 5.55379L5.46967 5.46967C5.73594 5.2034 6.1526 5.1792 6.44621 5.39705L6.53033 5.46967L12 10.939L17.4697 5.46967C17.7359 5.2034 18.1526 5.1792 18.4462 5.39705L18.5303 5.46967C18.7966 5.73594 18.8208 6.1526 18.6029 6.44621L18.5303 6.53033L13.061 12L18.5303 17.4697C18.7966 17.7359 18.8208 18.1526 18.6029 18.4462L18.5303 18.5303C18.2641 18.7966 17.8474 18.8208 17.5538 18.6029L17.4697 18.5303L12 13.061L6.53033 18.5303C6.26406 18.7966 5.8474 18.8208 5.55379 18.6029L5.46967 18.5303C5.2034 18.2641 5.1792 17.8474 5.39705 17.5538L5.46967 17.4697L10.939 12L5.46967 6.53033C5.2034 6.26406 5.1792 5.8474 5.39705 5.55379L5.46967 5.46967L5.39705 5.55379Z" fill="#626B79"/>
                    </svg>
                </button>
                </div>
            </div>
              <div className='filter-sort-container-root'>
                <div className="sort-filter-contents">
                  <div>
                      <span className='sort-filter-header-text'>
                          Sort by
                      </span>
                  </div>
                  <div className="radioGrp">
                      <span className='adv-sort-text'>ADV</span>
                      <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={value}
                          onChange={handleChange}
                      >
                          <FormControlLabel value="ADV-1" control={<Radio />} label="Low - High" />
                          <FormControlLabel value="ADV-2" control={<Radio />} label="High - Low" />
                      </RadioGroup>
                          </div>
                  <div className='radioGrp'> 
                      <span className='adv-sort-text'>ETR</span>
                      <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={value}
                          onChange={handleChange}
                      >
                          <FormControlLabel value="ETR-1" control={<Radio />} label="Low - High"/>
                          <FormControlLabel value="ETR-2" control={<Radio />} label="High - Low"/>
                      </RadioGroup>
                  </div>
                  <div className='radioGrp'>
                      <span className='adv-sort-text'>Hours open</span>
                      <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={value}
                          onChange={handleChange}
                      >
                          <FormControlLabel value="Hours Open-2" control={<Radio />} label="Low - High"/>
                          <FormControlLabel value="Hours Open-1" control={<Radio />} label="High - Low"/>
                      </RadioGroup>
                          </div>
                  <div className='radioGrp'>
                      <span className='adv-sort-text'>Station</span>
                      <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={value}
                          onChange={handleChange}
                      >
                          <FormControlLabel value="Station-1" control={<Radio />} label="A -Z"/>
                          <FormControlLabel value="Station-2" control={<Radio />} label="Z - A"/>
                      </RadioGroup>
                  </div>
                  <div className='radioGrp'>
                      <span className='adv-sort-text'>Aircraft</span>
                      <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={value}
                          onChange={handleChange}
                      >
                          <FormControlLabel value="Aircraft #-1" control={<Radio />} label="Low - High"/>
                          <FormControlLabel value="Aircraft #-2" control={<Radio />} label="High - Low"/>
                      </RadioGroup>
                          </div>
                  <div className='filter-root-container'>
                      <span className='sort-filter-header-text'>
                          Filter by
                      </span>
                  </div>
                  <div className='select-all-section'>
                    <span onClick={handleApplyAll} role="button" tabIndex={0} onKeyDown={(e)=>{if(e.key === 'Enter'){handleApplyAll()}}}>Apply all </span>
                    <span onClick={handleClearAll} role="button" tabIndex={0} onKeyDown={(e)=>{if(e.key === 'Enter'){handleClearAll()}}}>Clear all </span>
                  </div>

                  
                  <div className="event-list-section">
            <FormGroup className='form-group'>
                { Array.isArray(filters) &&
                        filters.map((eventType: EventTypeFilter) => (
                        eventType.IsActive && (<FormControlLabel
                        key={eventType.Name} 
                        control={<Checkbox onChange={(event) => eventTypeChecked(event, eventType.Name)} 
                        name={eventType.Name} 
                        disabled={eventType.IsLocked && eventType.IsChecked}
                        checked={eventType.IsChecked} />} 
                        label={<span className="sort-filter-event-text">{eventType.Name}</span>}
                        />
                        )                             
                ))
                }
                      </FormGroup>
                  </div>
              </div>
            </div> 
        </div>
    </div>
  );
}

export default FilterModal;